import { createFileRoute } from '@tanstack/react-router';
import { SyncHistoryAllPage } from '@/features/settings/ui/SyncHistoryAllPage';

export const Route = createFileRoute('/_authenticated/archive/history/')({ component: SyncHistoryAllPage });
